import type { TenantSecuritySettings } from '@detect/shared';

/** Why the "disable passwords" switch is unavailable, or null when it may be on. */
export function passwordToggleBlocker(s: TenantSecuritySettings): string | null {
  return s.ssoProviders.google || s.ssoProviders.microsoft
    ? null
    : 'Enable at least one SSO provider first.';
}

/** Turning the last provider off also turns "disable passwords" off: the API refuses the
 *  combination, and a tenant with no way in must be impossible to save. */
export function withProvider(
  s: TenantSecuritySettings,
  provider: 'google' | 'microsoft',
  enabled: boolean
): TenantSecuritySettings {
  const ssoProviders = { ...s.ssoProviders, [provider]: enabled };
  return {
    ssoProviders,
    localPasswordDisabled: s.localPasswordDisabled && (ssoProviders.google || ssoProviders.microsoft),
  };
}
